(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-countdown')) {
    class DeliveryCountdown extends HTMLElement {
      connectedCallback() {
        this.update();
        this.timer = setInterval(() => this.update(), 30000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      update() {
        const days = (this.dataset.days || '')
          .split(',')
          .filter((d) => d !== '')
          .map(Number);
        if (!days.length) return;

        const DAY = 86400000;
        const HOUR = 3600000;
        const cutoff = parseInt(this.dataset.cutoff, 10);
        const threshold = parseInt(this.dataset.threshold, 10) * HOUR;

        // Dubai is UTC+4 all year. Shift now into Dubai wall-clock time.
        const now = Date.now() + 4 * HOUR;
        const today = new Date(now);
        let target = Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate(), cutoff);
        if (now >= target) target += DAY;
        const remaining = target - now;

        // Delivery is the first delivery day after the cut-off date.
        let delivery = target;
        for (let i = 0; i < 7; i++) {
          delivery += DAY;
          if (days.includes(new Date(delivery).getUTCDay())) break;
        }

        const dayNumber = (ms) => Math.floor(ms / DAY);
        const names = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const day = dayNumber(delivery) - dayNumber(now) === 1 ? 'tomorrow' : names[new Date(delivery).getUTCDay()];
        const cutoffDay = dayNumber(target) === dayNumber(now) ? 'today' : 'tomorrow';
        const cutoffLabel = (cutoff % 12 || 12) + (cutoff < 12 ? 'am' : 'pm');

        const h = Math.floor(remaining / HOUR);
        const m = Math.floor((remaining % HOUR) / 60000);
        const countdown = h > 0 ? h + 'h ' + m + 'm' : Math.max(m, 1) + 'm';

        const template = remaining <= threshold ? this.dataset.templateCountdown : this.dataset.templateLater;
        if (!template) return;

        this.textContent = template
          .split('{countdown}').join(countdown)
          .split('{day}').join(day)
          .split('{cutoff_day}').join(cutoffDay)
          .split('{cutoff}').join(cutoffLabel);
      }
    }

    customElements.define('delivery-countdown', DeliveryCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
